import { render, staticRenderFns } from "./DarkTable.vue?vue&type=template&id=636a45e3&"
import script from "./DarkTable.vue?vue&type=script&lang=js&"
export * from "./DarkTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports